import { useState } from 'react'

export const NOVA = '__nova__'

// O marcador de "+ Nova…" nunca vira valor gravado: abre o campo vazio.
export function proximoValorDaLista(escolha: string): { valor: string; digitando: boolean } {
  return escolha === NOVA ? { valor: '', digitando: true } : { valor: escolha, digitando: false }
}

// Lista com o que ela ja usa + "+ Nova…" que troca por um campo de texto
// (spec 2026-09-30, decisao 6). <datalist> nao: nao abre no celular.
export default function CampoLista({ id, rotulo, valor, opcoes, textoNova, aoMudar }: {
  id: string; rotulo: string; valor: string; opcoes: string[]; textoNova: string; aoMudar: (v: string) => void
}) {
  const [digitando, setDigitando] = useState(false)
  // O valor de antes do "+ Nova": voltar para a Lista o devolve (revisao final
  // 30/09 -- sem isto a categoria antiga sumia e o Salvar a apagava).
  const [anterior, setAnterior] = useState(valor)
  const estilo = 'w-full min-w-0 border border-slate-300 rounded-lg px-3 py-2 bg-white'
  return (
    <div className="min-w-0">
      <label htmlFor={id} className="block text-sm text-slate-600 mb-1">{rotulo}</label>
      {digitando ? (
        <div className="flex gap-1">
          <input id={id} autoFocus value={valor} onChange={(e) => aoMudar(e.target.value)} className={estilo} />
          <button type="button" aria-label={`Voltar para a lista de ${rotulo}`}
            onClick={() => { aoMudar(anterior); setDigitando(false) }} className="shrink-0 px-2 text-teal-800 text-sm">Lista</button>
        </div>
      ) : (
        <select id={id} value={valor} className={estilo}
          onChange={(e) => { const r = proximoValorDaLista(e.target.value); if (r.digitando) setAnterior(valor); aoMudar(r.valor); setDigitando(r.digitando) }}>
          <option value="">Selecione…</option>
          {opcoes.map((o) => <option key={o} value={o}>{o}</option>)}
          <option value={NOVA}>{textoNova}</option>
        </select>
      )}
    </div>
  )
}
